import React from 'react';
import cn from 'clsx';
import {
  SelectionGroup as FrontonSelectionGroup,
  SelectionGroupItem,
  SelectionGroupProps as FrontonSelectionGroupProps,
} from 'fronton-react';
import { SelectionGroupValue as FrontonSelectionGroupValue } from 'fronton-react/selection-group/types';
import { css } from 'linaria';
import { createElementKey } from 'utils';
import { Swiper, SwiperSlide } from '../swiper';

export type SelectionGroupOption = {
  text: string;
  value: string;
};

export type SelectionGroupValue = FrontonSelectionGroupValue;

type SelectionGroupProps = {
  optionList: SelectionGroupOption[];
  isDesktopNoSwiping?: boolean;
  selectionGroupItemClassName?: string;
} & FrontonSelectionGroupProps;

const selectionGroup = css`
  width: 100%;
`;

const swiper = css`
  && {
    @media (--only-largeDesktop) {
      margin: 0;
    }

    @media (--only-desktop) {
      width: auto;
      padding-right: calc((100vw - 940px) / 2);
      padding-left: calc((100vw - 940px) / 2);
      margin-right: calc((-100vw + 940px) / 2);
      margin-left: calc((-100vw + 940px) / 2);
    }
  }
`;

const swiperDesktopNoSwiping = css`
  && {
    @media (--from-desktop) {
      width: 100%;
      padding: 0;
      margin: 0;

      .swiper-wrapper {
        flex-wrap: wrap;
      }

      .swiper-slide {
        height: auto;
      }
    }
  }
`;

const swiperItem = css`
  && {
    width: auto;

    &:first-of-type {
      button {
        margin-left: 0;
      }
    }

    &:last-child {
      button {
        margin-right: 0;
      }
    }
  }
`;

export const SelectionGroup: React.FC<SelectionGroupProps> = ({
  className,
  optionList,
  size = 'l',
  isDesktopNoSwiping = false,
  selectionGroupItemClassName,
  ...rest
}) => (
  <FrontonSelectionGroup className={cn(className, selectionGroup)} size={size} {...rest}>
    <Swiper
      centeredSlides
      breakpoints={{
        1024: {
          noSwiping: isDesktopNoSwiping,
          noSwipingSelector: '.swiper',
          centeredSlides: !isDesktopNoSwiping,
        },
      }}
      centeredSlidesBounds
      className={cn(swiper, { [swiperDesktopNoSwiping]: isDesktopNoSwiping })}
      slidesPerView="auto"
      slideToClickedSlide
      watchOverflow>
      {optionList.map(({ text, value }: SelectionGroupOption, index: number) => (
        <SwiperSlide className={swiperItem} key={createElementKey('selection-group-item', index)}>
          <SelectionGroupItem className={selectionGroupItemClassName} value={value}>{text}</SelectionGroupItem>
        </SwiperSlide>
      ))}
    </Swiper>
  </FrontonSelectionGroup>
);
